(function(window, document) {
  window.Auxito=window.Auxito || {};
  window.Auxito.CartDrawer = window.Auxito.CartDrawer || {};
  var cartDrawerNamespace = window.Auxito.CartDrawer;
  var cartService = window.Auxito.CartService || {};
  window.Auxito.CartService = cartService;
  if (cartDrawerNamespace.loaded) return;
  cartDrawerNamespace.loaded = true;
  var $ = window.jQuery || window.$;
  var STORAGE_CART_KEY = "auxito-cart-drawer:v5:cart";
  var HEADER_BUTTON_SELECTOR = ".js-site-header-cart--button";
  var TEMPLATE_SELECTOR = "[data-templates] [data-atc-banner]";
  function defineAliasProperty(name, getter, setter) {
    var descriptor = Object.getOwnPropertyDescriptor(window, name);
    if (descriptor && descriptor.configurable === false) {
      return;
    }
    Object.defineProperty(window, name, {
      configurable: true,
      enumerable: false,
      get: getter,
      set: setter
    });
  }
  defineAliasProperty("__auxitoCartDrawerLoaded", function() {
    return !!cartDrawerNamespace.loaded;
  }, function(value) {
    cartDrawerNamespace.loaded = !!value;
  });
  defineAliasProperty("_auxitoLatestCart", function() {
    return cartDrawerNamespace.latestCart || null;
  }, function(value) {
    cartDrawerNamespace.latestCart = value || null;
  });
  defineAliasProperty("AuxitoCartDrawerController", function() {
    return cartDrawerNamespace.controller || null;
  }, function(value) {
    cartDrawerNamespace.controller = value || null;
  });
  function cloneData(data) {
    if (!data) return null;
    try {
      return JSON.parse(JSON.stringify(data));
    } catch (error) {
      return data;
    }
  }
  function setLatestCart(cart) {
    cartDrawerNamespace.latestCart = cloneData(cart);
    return cartDrawerNamespace.latestCart;
  }
  var readSession = function(key) { return window.AuxitoUtils.readJson(window.sessionStorage, key); };
  var writeSession = function(key, value) { window.AuxitoUtils.writeJson(window.sessionStorage, key, value); };
  function matches(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    var fn = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    return fn ? fn.call(el, selector) : false;
  }
  function closest(el, selector) {
    while (el && el !== document) {
      if (matches(el, selector)) return el;
      el = el.parentNode;
    }
    return null;
  }
  function getCartLineItemId($element) {
    var itemKey = String($element.attr("data-item-key") || "").trim();
    var productId = String($element.attr("data-product_id") || "").trim();
    return itemKey || productId;
  }
  function isBlankFormData(formData) {
    if (formData == null) return true;
    if (typeof formData === "string") return !formData.replace(/\s+/g, "");
    if (formData.jquery) return !formData.length;
    if (Object.prototype.toString.call(formData) === "[object Array]") return formData.length === 0;
    if (typeof formData === "object") return !Object.keys(formData).length;
    return false;
  }
  function getTriggerElement(maybeJquery) {
    if (!maybeJquery) return null;
    if (maybeJquery.nodeType === 1) return maybeJquery;
    if (maybeJquery.jquery && maybeJquery.length) return maybeJquery[0];
    return null;
  }
  function isManagedCartFlyout(element) {
    if (!element || element.nodeType !== 1 || !matches(element, "[data-atc-banner]")) return false;
    if (closest(element, "[data-templates]")) return false;
    return matches(element, ".auxito-cart-drawer, .atc-banner--container");
  }
  function nodeContainsManagedCartFlyout(node) {
    var banners;
    var i;
    if (!node || node.nodeType !== 1) return false;
    if (isManagedCartFlyout(node)) return true;
    if (!node.querySelectorAll) return false;
    banners = node.querySelectorAll("[data-atc-banner]");
    for (i = 0; i < banners.length; i++) {
      if (isManagedCartFlyout(banners[i])) return true;
    }
    return false;
  }
  function closeLegacyFlyouts(activeDrawer) {
    if (!$) return;
    $("[data-atc-banner]").each(function() {
      var $banner = $(this);
      if (activeDrawer && activeDrawer.length && this === activeDrawer[0]) return;
      if ($banner.closest("[data-templates]").length) return;
      if (!isManagedCartFlyout(this)) return;
      if ($banner.hasClass("auxito-cart-drawer")) {
        $banner.removeClass("visible animating animating-in animating-out").removeAttr("data-flyout-active");
        return;
      }
      $banner.removeClass("visible animating animating-in animating-out").removeAttr("data-flyout-active").remove();
    });
  }
  function setLegacyTriggerPending(trigger, pending, wasDisabled) {
    if (!trigger) return;
    if (pending) {
      trigger.classList.add("processing");
      trigger.setAttribute("aria-busy", "true");
      if ("disabled" in trigger) trigger.disabled = true;
      return;
    }
    trigger.classList.remove("processing");
    trigger.removeAttribute("aria-busy");
    if ("disabled" in trigger) trigger.disabled = !!wasDisabled;
  }
  function runLegacyCallback(callbacks, name, payload) {
    if (!callbacks || typeof callbacks[name] !== "function") return;
    try {
      callbacks[name](payload);
    } catch (error) {
      console.warn("[auxito-cart-drawer] Legacy cart callback failed.", name, error);
    }
  }
  function ajaxJSON(options) {
    return new Promise(function(resolve, reject) {
      $.ajax(options).done(resolve).fail(reject);
    });
  }
  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function isDefaultOption(value) {
    return value === "" || value === "Title" || value === "Default Title";
  }
  function getCartSignature(cart) {
    var items = cart && cart.items || [];
    var itemSignature = items.map(function(item) {
      return [ item.key || item.id || "", item.quantity || 0, item.final_line_price || item.line_price || 0 ].join(":");
    }).join("|");
    return [ cart && cart.token || "", cart && cart.item_count || 0, cart && cart.total_price || 0, cart && cart.original_total_price || 0, itemSignature ].join("::");
  }
  function setMoney(el, cents, moneyFormat) {
    if (!el) return;
    if (typeof window.auxitoSetMoneyOnElement=== "function") {
      // 先清空再写：auxitoSetMoneyOnElement 依赖 Shopify.formatMoney，车型页等没加载 api.jquery.js 的页面上它会静默失败，
      // 不清空的话旧金额还在、下面的兜底不执行，删商品后小计不变（运营 2026-10-13 09 LED Builder）
      el.textContent = "";
      window.auxitoSetMoneyOnElement(el, cents || 0);
      if (el.textContent && el.textContent.trim()) return;
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      el.innerHTML = window.Shopify.formatMoney(cents || 0, moneyFormat);
      return;
    }
    el.textContent = "$" + ((Number(cents || 0) || 0) / 100).toFixed(2);
  }
  function getItemId(item) {
    return item && (item.key || item.id || "");
  }
  function getItemUrl(item) {
    return item && (item.url || item.product_url || "#") || "#";
  }
  function getItemImage(item) {
    if (!item) return "";
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return "";
  }
  function findCartLineByVariant(cart, variantId) {
    var items = cart && cart.items || [];
    var targetId = parseInt(variantId, 10);
    var i;
    var itemVariantId;
    if (!targetId) return null;
    for (i = 0; i < items.length; i++) {
      itemVariantId = parseInt(items[i].variant_id != null ? items[i].variant_id : items[i].id, 10);
      if (itemVariantId === targetId) return items[i];
    }
    return null;
  }
  function formatItemCount(count) {
    var safeCount = parseInt(count, 10) || 0;
    return safeCount === 1 ? "1 item" : safeCount + " items";
  }
  function buildOptionsHtml(item) {
    var options = item && item.options_with_values;
    var html = "";
    var index;
    if (options && options.length) {
      for (index = 0; index < options.length; index++) {
        if (!options[index] || isDefaultOption(options[index].value)) continue;
        html += '<span class="atc-options-item"><label class="atc-banner-label">' + escapeHtml(options[index].name) + "</label><span>" + escapeHtml(options[index].value) + "</span></span>";
      }
      return html;
    }
    options = item && item.variant_options;
    if (!options || !options.length || isDefaultOption(options[0])) return "";
    for (index = 0; index < options.length; index++) {
      if (isDefaultOption(options[index])) continue;
      html += '<span class="atc-options-item"><span>' + escapeHtml(options[index]) + "</span></span>";
    }
    return html;
  }
  function fallbackCartPage() {
    window.location.href = "/cart";
    return false;
  }
  function appendCartAddParam(params, name, value) {
    if (!name) return;
    if (value == null) value = "";
    if (typeof File !== "undefined" && value instanceof File) return;
    params.append(name, String(value));
  }
  function buildCartAddRequestBody(formData) {
    var params = new URLSearchParams();
    if (typeof formData === "string") {
      return formData;
    }
    if (Object.prototype.toString.call(formData) === "[object Array]") {
      formData.forEach(function(entry) {
        if (!entry) return;
        appendCartAddParam(params, entry.name, entry.value);
      });
    } else if (formData && typeof formData.forEach === "function") {
      formData.forEach(function(value, name) {
        appendCartAddParam(params, name, value);
      });
    } else if (formData && typeof formData === "object") {
      Object.keys(formData).forEach(function(name) {
        var value = formData[name];
        if (Object.prototype.toString.call(value) === "[object Array]") {
          value.forEach(function(item) {
            appendCartAddParam(params, name, item);
          });
          return;
        }
        appendCartAddParam(params, name, value);
      });
    }
    if (!params.has("quantity")) {
      params.set("quantity", "1");
    }
    return params.toString();
  }
  function parseCartAddError(response) {
    return response.json().then(function(payload) {
      return payload && (payload.description || payload.message || payload.status) || "";
    }).catch(function() {
      return "";
    });
  }
  function postCartAdd(formData) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: buildCartAddRequestBody(formData)
    }).then(function(response) {
      if (response.ok) return response.json();
      return parseCartAddError(response).then(function(message) {
        throw new Error(message || "Cart add failed: " + response.status);
      });
    });
  }
  function getController() {
    var controller = cartDrawerNamespace.controller || window.AuxitoCartDrawerController;
    if (!controller || typeof controller.fetchCart !== "function" || typeof controller.openWithCart !== "function") {
      return null;
    }
    if (typeof controller.canOpenDrawer === "function" && !controller.canOpenDrawer()) {
      return null;
    }
    return controller;
  }
  function fetchCart(force) {
    var controller = getController();
    if (controller) {
      return controller.fetchCart(force !== false);
    }
    return fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    }).then(function(response) {
      if (!response.ok) throw new Error("Cart fetch failed: " + response.status);
      return response.json();
    });
  }
  function publishCart(cart) {
    try {
      if (!cart || !cart.items) return;
      flushPendingCartAttrs(cart);
      setLatestCart(cart);
      writeSession(STORAGE_CART_KEY, cart);
      if ($) {
        $(document).trigger("cartcount:update", { response: cart });
        $(".site-header-wrapper").first().trigger("cartcount:update", { response: cart });
      }
      document.dispatchEvent(new window.CustomEvent("cart:refresh", { detail: { cart: cart } }));
    } catch (error) {}
  }
  /* 车型专题页订单归因（assets/auxito-proto-shell-tracking.js 记待写内容，这里在购物车刷新时写入私有属性；2026-10-14 与 Astra 联合评审三轮后定）
     - __apsp_vehicle_pages：这个购物车第一次来自哪个车型页；__apsp_builder：这个购物车用过的 Builder（09 / 10 都保留，逗号分隔）。
     - Builder 加购时先记成「未绑定」，下一次读到购物车（加购后侧边购物车 / 页头购物车 / 车型页读取）时绑定到该购物车，和来源一起写，换了新购物车不会继承。
     - 每次都写完整目标值（来源 + Builder 并集）。「已写入」按购物车记在 localStorage（多个标签页共用），只在写成功后才记。
     - 同一购物车同一时间只写一次：用浏览器 Web Locks（navigator.locks，跨标签页互斥）把「读记录—合并—写入—确认」串起来；
       不支持 Web Locks 的浏览器（很旧的版本）退回占位方式，只能尽力而为，多个标签页同时写时后写的来源可能覆盖先写的：写之前占位 20 秒，请求 8 秒超时，超时 / 失败只撤回自己的占位；占位过期后（页面关掉等）下次照常补写。
     - 测试中（测试者 / 调试开关 / 非正式主题，marketing-tags-head 的 __apspIsTest）写入的值都带「TEST 」前缀，已确认的普通来源也会改写成测试。
       迟到的成功（占位已被别的写入接手）不直接算确认，标记需要协调，等当前写入结束后再写一次完整值，保证最后到达的是完整值。
     - 写之前核对购物车 cookie 仍是这个购物车，避免旧购物车的待写写进新购物车。
     - 只在访客允许分析统计时写；明确拒绝时（包括之后在任何页面改成拒绝）清掉待写。 */
  var ATTR_PENDING_KEY = "apsp:pending-cart-attrs";
  var ATTR_RECORD_PREFIX = "apsp:cart-attrs:";
  var ATTR_CLAIM_MS = 20000;
  var ATTR_TIMEOUT_MS = 8000;
  var ATTR_UNBOUND_MS = 120000;
  var attrTabId = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  var attrRetryTimer = 0;
  function attrConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return "unknown";
      return cp.analyticsProcessingAllowed() ? "allowed" : "denied";
    } catch (error) { return "unknown"; }
  }
  function attrRead(store, key) {
    try { return JSON.parse(store.getItem(key) || "null"); } catch (error) { return null; }
  }
  function attrWrite(key, value) {
    try { if (value) window.localStorage.setItem(key, JSON.stringify(value)); else window.localStorage.removeItem(key); } catch (error) {}
  }
  function attrClearPending() {
    try { window.sessionStorage.removeItem(ATTR_PENDING_KEY); } catch (error) {}
  }
  function attrPrune() {
    try {
      var keys = [];
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf(ATTR_RECORD_PREFIX) === 0) keys.push([k, (attrRead(window.localStorage, k) || {}).t || 0]);
      }
      keys.sort(function(a, b) { return b[1] - a[1]; }).slice(10).forEach(function(e) { window.localStorage.removeItem(e[0]); });
    } catch (error) {}
  }
  function attrCookieToken() {
    var m = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie || "");
    if (!m) return "";
    try { return decodeURIComponent(m[1]).split("?")[0]; } catch (error) { return m[1].split("%3F")[0]; }
  }
  /* 稍后重新读取当前购物车再写（不沿用旧的购物车快照） */
  function attrRetryLater(ms) {
    if (attrRetryTimer) return;
    attrRetryTimer = window.setTimeout(function() {
      attrRetryTimer = 0;
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) { if (cart) flushPendingCartAttrs(cart); })
        .catch(function() {});
    }, ms);
  }
  function attrIsTest() {
    try { return typeof window.__apspIsTest === "function" && window.__apspIsTest(); } catch (error) { return false; }
  }
  function attrTestPrefix(v, test) {
    v = String(v || "");
    return test && v && v.indexOf("TEST ") !== 0 ? "TEST " + v : v;
  }
  function flushPendingCartAttrs(cart) {
    if (!cart || !cart.token) return attrWriteLocked(cart);
    var token = String(cart.token).split("?")[0];
    try {
      if (window.navigator && window.navigator.locks && typeof window.navigator.locks.request === "function") {
        return window.navigator.locks.request("apsp-cart-attrs:" + token, function() { return attrWriteLocked(cart); });
      }
    } catch (error) {}
    return attrWriteLocked(cart);
  }
  function attrWriteLocked(cart) {
    var consent = attrConsent();
    if (consent === "denied") { attrClearPending(); return Promise.resolve(false); }
    if (consent !== "allowed" || !cart || !cart.token || !cart.item_count) return Promise.resolve(false);
    var pending = null;
    try { pending = attrRead(window.sessionStorage, ATTR_PENDING_KEY); } catch (error) {}
    /* 本标签页没有待写：只有测试中才继续（把这个购物车已确认的普通来源 / Builder 改写成 TEST），否则不用写 */
    if (!pending) { if (!attrIsTest()) return Promise.resolve(false); pending = {}; }
    var token = String(cart.token).split("?")[0];
    var cookieToken = attrCookieToken();
    if (cookieToken && cookieToken !== token) return Promise.resolve(false); /* 浏览器当前购物车已不是这个：不写 */
    var now = Date.now();
    /* 未绑定的 Builder（加购后还没读到购物车）绑定到这个购物车 */
    if (Array.isArray(pending.unbound) && pending.unbound.length) {
      var map = pending.builders && typeof pending.builders === "object" ? pending.builders : {};
      var list = Array.isArray(map[token]) ? map[token] : [];
      var keep = [];
      pending.unbound.forEach(function(u) {
        if (!u || !u.n || now - (u.at || 0) >= ATTR_UNBOUND_MS) return;
        if (u.token !== token) { keep.push(u); return; } /* 只绑定到加购时的那个购物车 */
        if (list.indexOf(u.n) < 0) list.push(u.n);
      });
      map[token] = list;
      pending.builders = map;
      pending.unbound = keep;
      try { window.sessionStorage.setItem(ATTR_PENDING_KEY, JSON.stringify(pending)); } catch (error) {}
    }
    var recKey = ATTR_RECORD_PREFIX + token;
    var rec = attrRead(window.localStorage, recKey) || {};
    if (rec.p && now - (rec.p.at || 0) < ATTR_CLAIM_MS) { attrRetryLater(3000); return Promise.resolve(false); }
    var test = attrIsTest();
    var confirmedB = Array.isArray(rec.b) ? rec.b : [];
    var builders = [];
    var mine = pending.builders && Array.isArray(pending.builders[token]) ? pending.builders[token] : [];
    confirmedB.concat(mine).forEach(function(b) { b = attrTestPrefix(b, test); if (b && builders.indexOf(b) < 0) builders.push(b); });
    var wantV = attrTestPrefix(rec.v || (pending.__apsp_vehicle_pages ? String(pending.__apsp_vehicle_pages).slice(0, 120) : ""), test).slice(0, 120);
    var needed = rec.r || (wantV && wantV !== rec.v) || builders.join("|") !== confirmedB.join("|");
    if (!needed) return Promise.resolve(true);
    var out = {};
    if (wantV) out.__apsp_vehicle_pages = wantV;
    if (builders.length) out.__apsp_builder = builders.join(", ");
    var claimId = attrTabId + "-" + now;
    rec.p = { id: claimId, at: now };
    rec.t = now;
    attrWrite(recKey, rec);
    attrPrune();
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    var timer = window.setTimeout(function() { if (ctrl) ctrl.abort(); }, ATTR_TIMEOUT_MS);
    return fetch("/cart/update.js", { method: "POST", credentials: "same-origin", signal: ctrl ? ctrl.signal : undefined, headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: out }) })
      .then(function(r) { return r.ok; }, function() { return false; })
      .then(function(ok) {
        window.clearTimeout(timer);
        var cur = attrRead(window.localStorage, recKey) || {};
        var owner = cur.p && cur.p.id === claimId;
        if (owner) {
          if (ok) attrWrite(recKey, { v: wantV || cur.v, b: builders, t: Date.now() });
          else { delete cur.p; attrWrite(recKey, (cur.v || (cur.b && cur.b.length)) ? cur : null); }
        } else if (ok) {
          /* 迟到的成功：别的写入已接手，远端最终值不确定，等它结束后再写一次完整值 */
          cur.r = true;
          attrWrite(recKey, cur);
          attrRetryLater(ATTR_CLAIM_MS);
        }
        return ok;
      });
  }
  /* 访客在任何页面改成拒绝统计：清掉待写 */
  document.addEventListener("visitorConsentCollected", function() { if (attrConsent() === "denied") attrClearPending(); });
  window.AuxitoCartAttribution = { flush: flushPendingCartAttrs };

  /* 车型专题页埋点：上一页跳转前 Google 代码还没加载完、没送出的选车事件（tracking.js 存到本标签页），在下一页补发；
     放在全站都加载的侧边购物车脚本里，跳到旧版车型页等非专题页也能补发 */
  (function replayApspCarry(tries, state) {
    var q;
    if (state.done) return;
    try { q = JSON.parse(window.sessionStorage.getItem("apsp:carry") || "[]"); } catch (error) { return; }
    if (!q || !q.length) return;
    var cfg = window.__ga4ThemeConfig;
    if (!cfg || !cfg.measurementId || typeof window.gtag !== "function") return;
    /* 等本页 GA4 加载完再取出补发：gtag('get') 有回调说明这个 GA4 编号已加载完（正式站 GA4 由 GT- 容器稍后注册，
       注册前的 get 会被丢掉，所以每 0.5 秒问一次，最多 30 秒；google_tag_manager 里没有 G- 编号，不能按它判断）；
       本页没等到又跳走，下一页还能补 */
    try {
      window.gtag("get", cfg.measurementId, "client_id", function() {
        if (state.done) return;
        state.done = true;
        try {
          q = JSON.parse(window.sessionStorage.getItem("apsp:carry") || "[]");
          window.sessionStorage.removeItem("apsp:carry");
        } catch (error) { return; }
        sendApspCarry(q || [], cfg);
      });
    } catch (error) {}
    if (tries < 60) window.setTimeout(function() { replayApspCarry(tries + 1, state); }, 500);
  })(0, { done: false });
  function sendApspCarry(q, cfg) {
    q.forEach(function(e) {
      if (!e || !e.n || !e.p || Date.now() - (e.t || 0) > 600000) return;
      try {
        var dl = window.dataLayer = window.dataLayer || [];
        var data = { event: "apsp_event", apsp_event: e.n };
        Object.keys(e.p).forEach(function(k) { data[k] = e.p[k]; });
        dl.push(data);
        if (typeof window.gtag === "function") {
          var g = {};
          Object.keys(e.p).forEach(function(k) { g[k] = e.p[k]; });
          g.send_to = cfg.measurementId;
          window.gtag("event", e.n, g);
        }
      } catch (error) {}
    });
  }
  function openCart(cart, trigger) {
    var controller = getController();
    var headerButton;
    publishCart(cart);
    if (controller) {
      return controller.openWithCart(cart, trigger || null);
    }
    headerButton = document.querySelector(HEADER_BUTTON_SELECTOR);
    if (headerButton && typeof headerButton.click === "function") {
      headerButton.click();
      return Promise.resolve(cart);
    }
    fallbackCartPage();
    return Promise.resolve(cart);
  }
  function addAndOpen(formData, trigger) {
    return postCartAdd(formData).then(function() {
      return fetchCart(true);
    }).then(function(cart) {
      return openCart(cart, trigger);
    });
  }
  function isQuickshopProductForm(form) {
    var formArea;
    if (closest(form, "[data-product-quickshop]")) return true;
    if (closest(form, ".quickshop-full, .quickshop-slim, .modal, .modal-content")) return true;
    formArea = closest(form, "[data-product-form-area]");
    return !!(formArea && formArea.querySelector("[data-product-quickshop-message]"));
  }
  function isPdpProductForm(form) {
    if (!form || !matches(form, "[data-product-form]")) return false;
    if (!document.body || !document.body.classList.contains("template-product")) return false;
    if (!form.querySelector("[data-product-atc]")) return false;
    return !isQuickshopProductForm(form);
  }
  function getPdpAtcButton(form, event) {
    var submitter = event && event.submitter;
    if (submitter && form.contains(submitter) && matches(submitter, "[data-product-atc]")) {
      return submitter;
    }
    if (submitter && form.contains(submitter)) {
      submitter = closest(submitter, "[data-product-atc]");
      if (submitter) return submitter;
    }
    return form.querySelector("[data-product-atc]");
  }
  function shouldHandlePdpSubmit(form, event) {
    var submitter = event && event.submitter;
    if (!submitter) return true;
    return !!(form.contains(submitter) && (matches(submitter, "[data-product-atc]") || closest(submitter, "[data-product-atc]")));
  }
  function getProductFormData(form) {
    if (typeof window.FormData === "function") {
      return new window.FormData(form);
    }
    if ($) {
      return $(form).serializeArray();
    }
    return {};
  }
  function setPdpAtcPending(button, pending, wasDisabled) {
    if (!button) return;
    button.classList.toggle("processing", !!pending);
    if (pending) {
      button.setAttribute("data-auxito-atc-pending", "true");
      button.setAttribute("aria-busy", "true");
      button.disabled = true;
      return;
    }
    button.removeAttribute("data-auxito-atc-pending");
    button.removeAttribute("aria-busy");
    button.disabled = !!wasDisabled;
  }
  function shouldIgnoreAtcButton(button) {
    return !button || button.disabled || button.classList.contains("disabled") || button.getAttribute("aria-disabled") === "true";
  }
  function handlePdpAtc(form, event, button) {
    var wasDisabled;
    var formData;
    if (!isPdpProductForm(form)) return false;
    if (event && event.type === "submit" && !shouldHandlePdpSubmit(form, event)) return false;
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    button = button || getPdpAtcButton(form, event);
    if (shouldIgnoreAtcButton(button)) return true;
    if (button.getAttribute("data-auxito-atc-pending") === "true") return true;
    wasDisabled = button.disabled;
    formData = getProductFormData(form);
    setPdpAtcPending(button, true, wasDisabled);
    addAndOpen(formData, button).then(function() {
      setPdpAtcPending(button, false, wasDisabled);
    }, function(error) {
      setPdpAtcPending(button, false, wasDisabled);
      console.warn("[auxito-cart-drawer] PDP add-to-cart failed.", error);
    });
    return true;
  }
  function isPdpAtcTrigger(trigger) {
    var form = trigger ? closest(trigger, "[data-product-form]") : null;
    if (!form || !isPdpProductForm(form)) return false;
    return matches(trigger, "[data-product-atc]") || !!closest(trigger, "[data-product-atc]");
  }
  function forceLegacyPdpDrawer(options) {
    var nextOptions;
    var nextSettings;
    if (!options || !options.settings || options.settings.cartRedirection === false) return options;
    nextOptions = {};
    Object.keys(options).forEach(function(key) {
      nextOptions[key] = options[key];
    });
    nextSettings = {};
    Object.keys(options.settings).forEach(function(key) {
      nextSettings[key] = options.settings[key];
    });
    nextSettings.cartRedirection = false;
    nextOptions.settings = nextSettings;
    return nextOptions;
  }
  function isProductCardQuickBuy(button) {
    if (!button || !matches(button, "[data-quick-buy]")) return false;
    if (closest(button, "[data-atc-banner]")) return false;
    if (closest(button, "[data-search-result-handle]")) return false;
    if (closest(button, "[data-auxito-product-collection]")) return false;
    if (closest(button, ".quickshop-full, .quickshop-slim, .modal, .modal-content")) return false;
    if (closest(button, "[data-product-form], [data-product-form-area]")) return false;
    return !!closest(button, "[data-product-item], .productitem, .productgrid--item");
  }
  function getProductCardQuickBuyVariantId(button) {
    return String(button && button.getAttribute && button.getAttribute("data-variant-id") || "").trim();
  }
  function isProductCardQuickBuyPending(button) {
    return !!(button && button.getAttribute("data-auxito-card-atc-pending") === "true");
  }
  function setProductCardQuickBuyPending(button, pending, wasDisabled) {
    if (!button) return;
    setLegacyTriggerPending(button, pending, wasDisabled);
    if (pending) {
      button.setAttribute("data-auxito-card-atc-pending", "true");
      return;
    }
    button.removeAttribute("data-auxito-card-atc-pending");
  }
  function assignCartServiceApi() {
    cartDrawerNamespace.openCart = openCart;
    cartDrawerNamespace.addAndOpen = addAndOpen;
    cartDrawerNamespace.fetchCart = fetchCart;
    cartDrawerNamespace.getDrawerController = getController;
    cartService.buildCartAddRequestBody = buildCartAddRequestBody;
    cartService.postCartAdd = postCartAdd;
    cartService.fetchCart = fetchCart;
    cartService.publishCart = publishCart;
    cartService.openCart = openCart;
    cartService.addAndOpen = addAndOpen;
    cartService.getDrawerController = getController;
  }
  function HeaderCartDrawer() {
    this.cachedCart = readSession(STORAGE_CART_KEY);
    this.pendingCart = null;
    this.$template = $(TEMPLATE_SELECTOR).first();
    this.productTemplateHtml = this.$template.find("[data-atc-product-item]").first().prop("outerHTML") || "";
    this.moneyFormat = this.$template.attr("data-money-format") || window.Shopify && window.Shopify.money_format || "${{amount}}";
    this.$drawer = null;
    this.$header = $(".site-header-wrapper").first();
    this.isOpen = false;
    this.renderedSignature = "";
    this._boundOverlayClick = null;
    this.feedbackTimer = null;
    this.closeTimer = null;
    if (this.cachedCart && this.cachedCart.items) {
      setLatestCart(this.cachedCart);
    }
    this.bindGlobalEvents();
  }
  HeaderCartDrawer.prototype.setCachedCart = function(cart) {
    if (!cart || !cart.items) return;
    try { flushPendingCartAttrs(cart); } catch (error) {} /* 页头购物车读到购物车时也补写车型页归因 */
    this.cachedCart = cloneData(cart);
    setLatestCart(cart);
    writeSession(STORAGE_CART_KEY, cart);
  };
  HeaderCartDrawer.prototype.canOpenDrawer = function() {
    return !!(this.$template && this.$template.length);
  };
  HeaderCartDrawer.prototype.fetchCart = function(force) {
    var self = this;
    if (!force && this.cachedCart && this.cachedCart.items) {
      return Promise.resolve(cloneData(this.cachedCart));
    }
    if (this.pendingCart) {
      return this.pendingCart.then(function(cart) {
        return cloneData(cart);
      });
    }
    this.pendingCart = ajaxJSON({
      type: "GET",
      url: "/cart.js",
      dataType: "json"
    }).then(function(cart) {
      self.setCachedCart(cart);
      self.pendingCart = null;
      return cloneData(cart);
    }, function(error) {
      self.pendingCart = null;
      throw error;
    });
    return this.pendingCart.then(function(cart) {
      return cloneData(cart);
    });
  };
  HeaderCartDrawer.prototype.prefetch = function(force) {
    return this.fetchCart(force).catch(function() {
      return null;
    });
  };
  HeaderCartDrawer.prototype.bindGlobalEvents = function() {
    var self = this;
    this._handlers = {};
    $(document).on("cartcount:update.auxito-cart-drawer", function(event, payload) {
      var cart = payload && payload.response;
      if (!cart || !cart.items) return;
      self.setCachedCart(cart);
    });
    this._handlers.clickOpen = function(event) {
      var button = closest(event.target, HEADER_BUTTON_SELECTOR);
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!self.canOpenDrawer()) {
        fallbackCartPage();
        return;
      }
      self.open(button).catch(function() {
        fallbackCartPage();
      });
    };
    this._handlers.mouseover = function(event) {
      if (!closest(event.target, HEADER_BUTTON_SELECTOR)) return;
      self.prefetch(false);
    };
    this._handlers.focusin = function(event) {
      if (!closest(event.target, HEADER_BUTTON_SELECTOR)) return;
      self.prefetch(false);
    };
    this._handlers.touchstart = function(event) {
      if (!closest(event.target, HEADER_BUTTON_SELECTOR)) return;
      self.prefetch(false);
    };
    this._handlers.clickPdpAtc = function(event) {
      var button = closest(event.target, "[data-product-atc]");
      var form = button ? closest(button, "[data-product-form]") : null;
      handlePdpAtc(form, event, button);
    };
    this._handlers.submitPdpAtc = function(event) {
      handlePdpAtc(event.target, event);
    };
    this._handlers.clickProductCardQuickBuy = function(event) {
      var button = closest(event.target, "[data-quick-buy]");
      var variantId;
      var wasDisabled;
      if (!isProductCardQuickBuy(button)) return;
      if (button.disabled || button.classList.contains("disabled") || button.getAttribute("aria-disabled") === "true") return;
      if (isProductCardQuickBuyPending(button)) return;
      variantId = getProductCardQuickBuyVariantId(button);
      if (!variantId) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      wasDisabled = button.disabled;
      setProductCardQuickBuyPending(button, true, wasDisabled);
      addAndOpen([
        { name: "id", value: variantId },
        { name: "quantity", value: "1" }
      ], button).then(function() {
        setProductCardQuickBuyPending(button, false, wasDisabled);
      }, function(error) {
        setProductCardQuickBuyPending(button, false, wasDisabled);
        console.warn("[auxito-cart-drawer] Product card add-to-cart failed.", error);
      });
    };
    this._handlers.clickClose = function(event) {
      if (!self.isOpen) return;
      if (closest(event.target, HEADER_BUTTON_SELECTOR)) return;
      if (closest(event.target, "[data-atc-banner]")) return;
      self.close();
    };
    this._handlers.keydown = function(event) {
      if (!self.isOpen) return;
      if (event.key !== "Escape") return;
      self.close();
    };
    this._handlers.resize = function() {
      if (!self.isOpen) return;
      self.positionDrawer();
    };
    this._handlers.scroll = function() {
      if (!self.isOpen) return;
      self.positionDrawer();
    };
    document.addEventListener("click", this._handlers.clickOpen, true);
    document.addEventListener("mouseover", this._handlers.mouseover, true);
    document.addEventListener("focusin", this._handlers.focusin, true);
    document.addEventListener("touchstart", this._handlers.touchstart, { passive: true, capture: true });
    document.addEventListener("click", this._handlers.clickPdpAtc, true);
    document.addEventListener("submit", this._handlers.submitPdpAtc, true);
    document.addEventListener("click", this._handlers.clickProductCardQuickBuy, true);
    document.addEventListener("click", this._handlers.clickClose, true);
    document.addEventListener("keydown", this._handlers.keydown, true);
    window.addEventListener("resize", this._handlers.resize);
    window.addEventListener("scroll", this._handlers.scroll, true);
    if (typeof window.requestIdleCallback=== "function") {
      window.requestIdleCallback(function() {
        self.prefetch(true);
      }, {
        timeout: 1500
      });
    } else {
      window.setTimeout(function() {
        self.prefetch(true);
      }, 800);
    }
  };
  HeaderCartDrawer.prototype.destroy = function() {
    $(document).off(".auxito-cart-drawer");
    if (!this._handlers) return;
    document.removeEventListener("click", this._handlers.clickOpen, true);
    document.removeEventListener("mouseover", this._handlers.mouseover, true);
    document.removeEventListener("focusin", this._handlers.focusin, true);
    document.removeEventListener("touchstart", this._handlers.touchstart, { passive: true, capture: true });
    document.removeEventListener("click", this._handlers.clickPdpAtc, true);
    document.removeEventListener("submit", this._handlers.submitPdpAtc, true);
    document.removeEventListener("click", this._handlers.clickProductCardQuickBuy, true);
    document.removeEventListener("click", this._handlers.clickClose, true);
    document.removeEventListener("keydown", this._handlers.keydown, true);
    window.removeEventListener("resize", this._handlers.resize);
    window.removeEventListener("scroll", this._handlers.scroll, true);
    this._handlers = null;
    if (this.$drawer && this.$drawer.length) {
      this.$drawer.off(".auxito-cart-drawer").remove();
    }
  };
  HeaderCartDrawer.prototype.ensureDrawer = function() {
    var self = this;
    if (this.$drawer && this.$drawer.length && document.body.contains(this.$drawer[0])) {
      return this.$drawer;
    }
    if (!this.$template.length) return $();
    this.$drawer = this.$template.clone();
    this.$drawer.addClass("auxito-cart-drawer").removeClass("visible animating animating-in animating-out").removeAttr("data-flyout-active").attr("data-prod_count", "0");
    this.$drawer.find("[data-atc-products]").empty();
    $(document.body).append(this.$drawer);
    this.$drawer.on("click.auxito-cart-drawer", "[data-atc-banner-close]", function(event) {
      event.preventDefault();
      self.close();
    });
    this.$drawer.on("change.auxito-cart-drawer", "[data-cartitem-quantity-fly]", function(event) {
      self.updateItemQuantity(event.currentTarget);
    });
    this.$drawer.on("change.auxito-cart-drawer", ".atc-variant-select", function(event) {
      self.updateRecommendedVariant(event.currentTarget);
    });
    this.$drawer.on("click.auxito-cart-drawer", "[data-atc-remove-item]", function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      self.removeItem(event.currentTarget);
    });
    this.$drawer.on("click.auxito-cart-drawer", "[data-trending-quick], .atc-recommended-add-btn", function(event) {
      var button = this;
      if (closest(button, "[data-atc-products]")) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      self.addRecommendedItem(button).catch(function() {});
    });
    if (!this._boundOverlayClick) {
      this._boundOverlayClick = function() {
        self.close();
      };
      $("#overlay").on("click.auxito-cart-drawer", this._boundOverlayClick);
    }
    return this.$drawer;
  };
  HeaderCartDrawer.prototype.createProductNode = function(item) {
    var $item = $(this.productTemplateHtml);
    var title = item.product_title || item.title || "";
    var url = getItemUrl(item);
    var image = getItemImage(item);
    var optionsHtml = buildOptionsHtml(item);
    var itemId = getItemId(item);
    var $imageLink = $item.find("[data-atc-banner-product-image]");
    var $titleLink = $item.find("[data-atc-banner-product-title-link]");
    var $title = $item.find("[data-atc-banner-product-title]");
    var $options = $item.find("[data-atc-banner-product-options]");
    var $quantity = $item.find("[data-atc-banner-update]");
    var $remove = $item.find("[data-atc-remove-item]");
    var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
    var originalLinePrice = item.original_line_price != null ? item.original_line_price : linePrice;
    var linePriceEl = $item.find("[data-atc-banner-product-item-price]")[0];
    var originalLinePriceEl = $item.find("[data-atc-banner-product-item-price-original]")[0];
    if ($imageLink.length) {
      $imageLink.attr("href", url);
      if (image) {
        $imageLink.html('<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '">');
      }
    }
    if ($titleLink.length) {
      $titleLink.attr("href", url);
    }
    if ($title.length) {
      $title.text(title).attr("title", title);
    }
    if ($options.length) {
      $options.html(optionsHtml);
    }
    if ($quantity.length) {
      $quantity.val(item.quantity).attr("data-product_id", itemId).attr("data-item-key", item.key || itemId);
    }
    if ($remove.length) {
      $remove.attr("data-product_id", itemId).attr("data-item-key", item.key || itemId);
    }
    setMoney(linePriceEl, linePrice, this.moneyFormat);
    if (originalLinePriceEl) {
      if ((originalLinePrice || 0) > (linePrice || 0)) {
        setMoney(originalLinePriceEl, originalLinePrice, this.moneyFormat);
        originalLinePriceEl.style.display = "";
      } else {
        originalLinePriceEl.style.display = "none";
      }
    }
    return $item;
  };
  HeaderCartDrawer.prototype.setRecommendedButtonState = function(button, state) {
    if (!button) return;
    if (button.__auxitoStateTimer) {
      window.clearTimeout(button.__auxitoStateTimer);
      button.__auxitoStateTimer = null;
    }
    button.setAttribute("data-atc-state", state || "idle");
  };
  HeaderCartDrawer.prototype.resetRecommendedButtonState = function(button, delay) {
    var self = this;
    if (!button) return;
    if (button.__auxitoStateTimer) {
      window.clearTimeout(button.__auxitoStateTimer);
    }
    button.__auxitoStateTimer = window.setTimeout(function() {
      self.setRecommendedButtonState(button, "idle");
    }, delay || 1600);
  };
  HeaderCartDrawer.prototype.showRecommendedFeedback = function(message, options) {
    var $drawer = this.ensureDrawer();
    var $feedback = $drawer.find("[data-atc-feedback]").first();
    var $text = $drawer.find("[data-atc-feedback-text]").first();
    options = options || {};
    if (!$feedback.length || !$text.length) return;
    if (this.feedbackTimer) {
      window.clearTimeout(this.feedbackTimer);
      this.feedbackTimer = null;
    }
    $text.text(message || "");
    $feedback.attr("data-feedback-type", options.type || "success").prop("hidden", !message);
    if (!message) return;
    this.feedbackTimer = window.setTimeout(function() {
      $feedback.prop("hidden", true);
    }, options.duration || 3200);
  };
  HeaderCartDrawer.prototype.pulseElement = function($element) {
    var element;
    if (!$element || !$element.length) return;
    element = $element[0];
    if (element.__auxitoPulseTimer) {
      window.clearTimeout(element.__auxitoPulseTimer);
    }
    $element.removeClass("is-pulsing");
    void element.offsetWidth;
    $element.addClass("is-pulsing");
    element.__auxitoPulseTimer = window.setTimeout(function() {
      $element.removeClass("is-pulsing");
    }, 850);
  };
  HeaderCartDrawer.prototype.pulseCheckoutTargets = function() {
    var $drawer = this.ensureDrawer();
    this.pulseElement($drawer.find("[data-atc-banner-cart-subtotal-s]").first());
    this.pulseElement($drawer.find("#atc-button-checkout-action").first());
  };
  HeaderCartDrawer.prototype.updateCheckoutMeta = function(cart) {
    var $drawer = this.ensureDrawer();
    var $count = $drawer.find("[data-atc-checkout-count]").first();
    var itemCount = cart && cart.item_count != null ? cart.item_count : 0;
    if (!$count.length) return;
    $count.text(formatItemCount(itemCount));
  };
  HeaderCartDrawer.prototype.renderCart = function(cart) {
    var $drawer = this.ensureDrawer();
    var $products;
    var items;
    var i;
    var subtotalEl;
    var noteValue;
    if (!$drawer.length || !cart || !cart.items) return;
    $products = $drawer.find("[data-atc-products]").first();
    items = cart.items || [];
    $products.empty();
    for (i = 0; i < items.length; i++) {
      $products.append(this.createProductNode(items[i]));
    }
    noteValue = typeof cart.note === "string" ? cart.note : "";
    $drawer.find(".js-atc-cart-note").first().val(noteValue);
    $drawer.attr("data-prod_count", String(cart.item_count || items.length || 0));
    this.updateCheckoutMeta(cart);
    subtotalEl = $drawer.find("[data-atc-banner-cart-subtotal]").first()[0];
    setMoney(subtotalEl, cart.original_total_price != null ? cart.original_total_price : cart.total_price, this.moneyFormat);
    if (typeof window.auxitoRefreshBannerCurrency=== "function") {
      window.auxitoRefreshBannerCurrency();
    }
    this.renderedSignature = getCartSignature(cart);
    this.setCachedCart(cart);
    if (this.$header.length) {
      this.$header.trigger("cartcount:update", {
        response: cart
      });
    }
    if (typeof window.auxitoUpdateCartDiscount=== "function") {
      window.auxitoUpdateCartDiscount(cart);
    }
  };
  HeaderCartDrawer.prototype.positionDrawer = function() {
    if (!this.$drawer || !this.$drawer.length) return;
    if (window.nn && typeof window.nn._positionFlyOut === "function") {
      window.nn._positionFlyOut(this.$drawer);
      return;
    }
    var header = document.querySelector(".site-header-wrapper");
    var top = 0;
    if (header) {
      top = header.getBoundingClientRect().bottom || header.offsetHeight || 0;
    }
    this.$drawer.css({
      top: top
    });
  };
  HeaderCartDrawer.prototype.openDrawer = function() {
    var $drawer = this.ensureDrawer();
    if (!$drawer.length) return;
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (window.nn && typeof window.nn._closeFlyOuts === "function") {
      try {
        window.nn._closeFlyOuts($drawer);
      } catch (error) {}
    }
    closeLegacyFlyouts($drawer);
    this.positionDrawer();
    $("#overlay").addClass("is-active");
    $("body").addClass("atc-cart-active");
    $drawer.removeClass("animating animating-in animating-out").addClass("visible").attr("data-flyout-active", "true");
    this.isOpen = true;
    try {
      document.dispatchEvent(new window.CustomEvent("cart:opened"));
    } catch (error) {}
    $(document).trigger("atc-banner:opened");
  };
  HeaderCartDrawer.prototype.close = function() {
    var self = this;
    var $drawer;
    if (!this.isOpen || !this.$drawer || !this.$drawer.length) return;
    this.isOpen = false;
    $drawer = this.$drawer;
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
    }
    $drawer.removeClass("visible animating-in").addClass("animating animating-out").removeAttr("data-flyout-active");
    this.closeTimer = window.setTimeout(function() {
      $("#overlay").removeClass("is-active");
      $("body").removeClass("atc-cart-active");
      $drawer.removeClass("animating animating-out");
      self.closeTimer = null;
    }, 140);
  };
  HeaderCartDrawer.prototype.open = function() {
    var self = this;
    var trigger = arguments.length > 0 ? arguments[0] : null;
    var cachedSignature = this.cachedCart ? getCartSignature(this.cachedCart) : "";
    if (this.cachedCart && this.cachedCart.items) {
      this.renderCart(this.cachedCart);
      this.openDrawer(trigger);
      return this.fetchCart(true).then(function(freshCart) {
        if (!self.isOpen) return freshCart;
        if (getCartSignature(freshCart) !== cachedSignature) {
          self.renderCart(freshCart);
        }
        return freshCart;
      }).catch(function() {
        return cloneData(self.cachedCart);
      });
    }
    return this.fetchCart(false).then(function(cart) {
      self.renderCart(cart);
      self.openDrawer(trigger);
      return cart;
    });
  };
  HeaderCartDrawer.prototype.openWithCart = function(cart) {
    var self = this;
    var trigger = arguments.length > 1 ? arguments[1] : null;
    if (!cart || !cart.items) {
      return this.open(trigger);
    }
    return this.syncCartState(cart).then(function(nextCart) {
      var resolvedCart = nextCart && nextCart.items ? nextCart : cart;
      self.renderCart(resolvedCart);
      self.openDrawer(trigger);
      return resolvedCart;
    }, function() {
      self.renderCart(cart);
      self.openDrawer(trigger);
      return cart;
    });
  };
  HeaderCartDrawer.prototype.syncCartState = function(cart) {
    var timeoutId;
    var settled = false;
    function resolveOnce(resolve, nextCart) {
      if (settled) return;
      settled = true;
      if (timeoutId) {
        window.clearTimeout(timeoutId);
        timeoutId = null;
      }
      resolve(nextCart && nextCart.items ? nextCart : cart);
    }
    if (!cart || !cart.items || typeof window.checkDiscountProduct !== "function") {
      return Promise.resolve(cart);
    }
    return new Promise(function(resolve) {
      timeoutId = window.setTimeout(function() {
        console.warn("[auxito-cart-drawer] Discount cart sync timed out; opening with current cart.");
        resolveOnce(resolve, cart);
      }, 3500);
      try {
        window.checkDiscountProduct(cloneData(cart), function(nextCart) {
          resolveOnce(resolve, nextCart);
        });
      } catch (error) {
        console.warn("[auxito-cart-drawer] Failed to sync discount cart state.", error);
        resolveOnce(resolve, cart);
      }
    });
  };
  HeaderCartDrawer.prototype.updateItemQuantity = function(input) {
    var self = this;
    var itemId = getCartLineItemId($(input));
    var quantity = parseInt(input.value, 10);
    var $row = $(input).closest(".atc--product");
    if (!itemId) return;
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    this.showRecommendedFeedback("", {});
    input.value = quantity;
    $row.addClass("auxito-cart-item--pending");
    ajaxJSON({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: itemId,
        quantity: quantity
      },
      dataType: "json"
    }).then(function(cart) {
      return self.syncCartState(cart);
    }).then(function(cart) {
      self.renderCart(cart);
    }).catch(function() {
      window.location.href = "/cart";
    });
  };
  HeaderCartDrawer.prototype.removeItem = function(button) {
    var self = this;
    var $button = $(button);
    var itemId = getCartLineItemId($button);
    var $row = $button.closest(".atc--product");
    if (!itemId) return;
    if ($button.attr("data-auxito-remove-pending") === "true") return;
    this.showRecommendedFeedback("", {});
    $button.attr("data-auxito-remove-pending", "true").attr("aria-busy", "true").prop("disabled", true);
    $row.addClass("auxito-cart-item--pending");
    ajaxJSON({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: itemId,
        quantity: 0
      },
      dataType: "json"
    }).then(function(cart) {
      return self.syncCartState(cart);
    }).then(function(cart) {
      self.renderCart(cart);
    }).catch(function(error) {
      console.warn("[auxito-cart-drawer] Remove item failed.", error);
      $button.removeAttr("data-auxito-remove-pending").removeAttr("aria-busy").prop("disabled", false);
      $row.removeClass("auxito-cart-item--pending");
      window.location.href = "/cart";
    });
  };
  HeaderCartDrawer.prototype.updateRecommendedVariant = function(select) {
    var $select = $(select);
    var $item = $select.closest(".atc-recommended-item");
    var $button = $item.find(".atc-recommended-add-btn").first();
    var $price = $item.find(".atc-recommended-price-display").first();
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var variantId = option ? option.value : "";
    var price = option ? parseInt(option.getAttribute("data-price"), 10) : NaN;
    var isDisabled = !!(option && option.disabled);
    if ($button.length) {
      $button.attr("data-variant-id", variantId || "").prop("disabled", isDisabled || !variantId).attr("data-atc-state", "idle");
    }
    if ($price.length && Number.isFinite(price)) {
      setMoney($price[0], price, this.moneyFormat);
    }
  };
  HeaderCartDrawer.prototype.addRecommendedItem = function(button) {
    var self = this;
    var $button = $(button);
    var $item = $button.closest(".atc-recommended-item");
    var select = $item.find(".atc-variant-select").first()[0];
    var variantId;
    var productTitle = $button.attr("data-product-title") || $.trim($item.find(".atc-recommended-title").first().text()) || "Item";
    var wasDisabled;
    if ($button.attr("data-auxito-atc-pending") === "true") return Promise.resolve(null);
    if (select) {
      this.updateRecommendedVariant(select);
    }
    variantId = parseInt($button.attr("data-variant-id"), 10);
    if (!variantId) {
      console.warn("[auxito-cart-drawer] Missing recommended variant id.", button);
      return Promise.resolve(null);
    }
    wasDisabled = $button.prop("disabled");
    $button.attr("data-auxito-atc-pending", "true").attr("aria-busy", "true").prop("disabled", true);
    this.setRecommendedButtonState(button, "loading");
    return ajaxJSON({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: "json"
    }).then(function() {
      return self.fetchCart(true);
    }).then(function(cart) {
      return self.syncCartState(cart);
    }).then(function(cart) {
      self.renderCart(cart);
      self.openDrawer();
      self.pulseCheckoutTargets();
      self.showRecommendedFeedback(productTitle + " added to cart.", {
        type: "success"
      });
      $button.removeAttr("data-auxito-atc-pending").removeAttr("aria-busy").prop("disabled", wasDisabled);
      self.setRecommendedButtonState(button, "success");
      self.resetRecommendedButtonState(button, 1600);
      return cart;
    }, function(error) {
      $button.removeAttr("data-auxito-atc-pending").removeAttr("aria-busy").prop("disabled", wasDisabled);
      self.setRecommendedButtonState(button, "idle");
      console.warn("[auxito-cart-drawer] Failed to add recommended product from drawer.", {
        variantId: variantId,
        error: error
      });
      self.showRecommendedFeedback("Unable to add " + productTitle + " right now.", {
        type: "error",
        duration: 3200
      });
      throw error;
    });
  };
  function patchLegacyInit(controller) {
    if (!window.nn || typeof window.nn.init !== "function") return false;
    if (window.nn.init.__auxitoHeaderCartPatched) return true;
    var originalInit = window.nn.init;
    window.nn.init = function(formData, options, callbacks) {
      var trigger;
      var wasDisabled;
      var request;
      trigger = getTriggerElement(options && options.$atcButton);
      if (isPdpAtcTrigger(trigger)) {
        options = forceLegacyPdpDrawer(options);
      }
      if (options && options.showCart && isBlankFormData(formData)) {
        if (!controller.canOpenDrawer()) {
          fallbackCartPage();
          return false;
        }
        wasDisabled = trigger && "disabled" in trigger ? trigger.disabled : false;
        runLegacyCallback(callbacks, "onInit");
        setLegacyTriggerPending(trigger, true, wasDisabled);
        closeLegacyFlyouts(controller.$drawer);
        request = controller.open(trigger);
        request.then(function(cart) {
          setLegacyTriggerPending(trigger, false, wasDisabled);
          runLegacyCallback(callbacks, "onOpen", {
            $container: controller.$drawer,
            $elementToFocus: controller.$drawer && controller.$drawer.length ? controller.$drawer.find("[data-atc-banner-cart-button], [data-atc-banner-close]").first() : $()
          });
          runLegacyCallback(callbacks, "onSuccess", cart);
        }).catch(function(error) {
          setLegacyTriggerPending(trigger, false, wasDisabled);
          runLegacyCallback(callbacks, "onError", error);
          console.warn("[auxito-cart-drawer] Legacy cart handoff failed.", error);
          if (!callbacks || typeof callbacks.onError !== "function") {
            fallbackCartPage();
          }
        });
        return false;
      }
      return originalInit.apply(this, arguments);
    };
    window.nn.init.__auxitoHeaderCartPatched = true;
    window.nn.init.__auxitoOriginal = originalInit;
    return true;
  }
  function patchLegacyFlyoutOpen(controller) {
    if (!window.nn || typeof window.nn._openFlyOut !== "function") return false;
    if (window.nn._openFlyOut.__auxitoHeaderCartPatched) return true;
    var originalOpenFlyOut = window.nn._openFlyOut;
    window.nn._openFlyOut = function($flyOut, $atcButton) {
      var trigger;
      if ($flyOut && $flyOut.jquery && isManagedCartFlyout($flyOut[0]) && !$flyOut.hasClass("auxito-cart-drawer")) {
        trigger = getTriggerElement($atcButton);
        $flyOut.remove();
        closeLegacyFlyouts(controller.$drawer);
        if (controller.canOpenDrawer()) {
          controller.fetchCart(true).then(function(cart) {
            return controller.openWithCart(cart, trigger);
          }).catch(function(error) {
            console.warn("[auxito-cart-drawer] Legacy flyout display handoff failed.", error);
            controller.open(trigger).catch(function(openError) {
              console.warn("[auxito-cart-drawer] Legacy flyout fallback open failed.", openError);
            });
          });
        }
        return;
      }
      return originalOpenFlyOut.apply(this, arguments);
    };
    window.nn._openFlyOut.__auxitoHeaderCartPatched = true;
    window.nn._openFlyOut.__auxitoOriginal = originalOpenFlyOut;
    return true;
  }
  function installSingleDrawerGuard(controller) {
    var observer;
    var cleanupTimer = null;
    function scheduleCleanup() {
      if (cleanupTimer !== null) return;
      cleanupTimer = window.setTimeout(function() {
        cleanupTimer = null;
        closeLegacyFlyouts(controller.$drawer);
      }, 50);
    }
    if (!window.MutationObserver || cartDrawerNamespace.singleDrawerGuardInstalled) return;
    cartDrawerNamespace.singleDrawerGuardInstalled = true;
    observer = new window.MutationObserver(function(mutations) {
      var shouldClean = false;
      mutations.forEach(function(mutation) {
        var i;
        for (i = 0; i < mutation.addedNodes.length; i++) {
          if (nodeContainsManagedCartFlyout(mutation.addedNodes[i])) {
            shouldClean = true;
            break;
          }
        }
      });
      if (shouldClean) {
        scheduleCleanup();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    cartDrawerNamespace.singleDrawerGuard = observer;
  }
  function boot() {
    if (!$) return;
    var controller = new HeaderCartDrawer();
    cartDrawerNamespace.controller = controller;
    installSingleDrawerGuard(controller);
    patchLegacyInit(controller);
    patchLegacyFlyoutOpen(controller);
    var resolved = false;
    var timeoutId = null;
    var observer = new window.MutationObserver(function() {
      var initPatched = patchLegacyInit(controller);
      var flyoutPatched = patchLegacyFlyoutOpen(controller);
      if (initPatched && flyoutPatched) {
        resolved = true;
        observer.disconnect();
        window.clearTimeout(timeoutId);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    timeoutId = window.setTimeout(function() {
      if (!resolved) {
        observer.disconnect();
        console.warn("[auxito-cart-drawer] Legacy cart patch timed out after 4s");
      }
    }, 4000);
  }
  assignCartServiceApi();
  boot();
})(window, document);
